import { render } from "./IconPicker.vue?vue&type=template&id=20de4dba&ts=true"
import script from "./IconPicker.vue?vue&type=script&lang=ts"
export * from "./IconPicker.vue?vue&type=script&lang=ts"

import "./IconPicker.vue?vue&type=style&index=0&id=20de4dba&lang=css"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__